import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// Importing the Bootstrap CSS as per https://react-bootstrap.netlify.app/docs/getting-started/introduction#css
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';


const mainContainer: HTMLElement | null = document.getElementById('root')
if (mainContainer) {
  const root = ReactDOM.createRoot(mainContainer);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );   
}
